import { ROUTES } from 'router/routes';
import { OnboardingV4FlowID } from 'config/onboardingV4/flows';
import { useMultivariateFlag } from './useMultivariateFlag';

/** Picks the onboarding version someone gets; v2 when it names none. */
export const ONBOARDING_FLOW_FLAG = 'onboarding-flow';

/** What the flag can pick: v2, or a v4 flow by its id. */
export type OnboardingVariant = 'v2' | OnboardingV4FlowID;

export const ONBOARDING_ROUTES: Record<OnboardingVariant, string> = {
  v2: ROUTES.ONBOARDING,
  'talk-first': ROUTES.ONBOARDING_V4,
  'talk-first-orb': ROUTES.ONBOARDING_V4,
  'talk-first-every-question': ROUTES.ONBOARDING_V4,
  'talk-first-no-questions': ROUTES.ONBOARDING_V4,
  'questions-first': ROUTES.ONBOARDING_V4,
  'talk-first-more-questions': ROUTES.ONBOARDING_V4,
  'talk-first-live': ROUTES.ONBOARDING_V4,
  'talk-first-live-full': ROUTES.ONBOARDING_V4,
};

/** Where someone not yet onboarded goes. */
export const useOnboardingRoute = () =>
  useMultivariateFlag(ONBOARDING_FLOW_FLAG, ONBOARDING_ROUTES, 'v2');
